import React from 'react';
import { NoticeModel } from '../../../../models';
import { Bell, Pin, ChevronRight, Eye } from 'lucide-react';

interface StudentNoticeCardProps {
    notice: NoticeModel;
    onView: () => void;
}

const StudentNoticeCard: React.FC<StudentNoticeCardProps> = ({ notice, onView }) => {
    return (
        <button
            onClick={onView}
            className={`w-full group text-left bg-white p-4 sm:p-5 rounded-2xl border transition-all hover:shadow-lg hover:shadow-indigo-100/30 flex items-center gap-4 ${notice.isPinned ? 'border-indigo-500/20 bg-indigo-50/5' : 'border-slate-100 hover:border-indigo-100'
                }`}
        >
            <div className={`w-10 h-10 rounded-xl shrink-0 flex items-center justify-center transition-all group-hover:scale-110 ${notice.category === '중요' ? 'bg-rose-100 text-rose-600' :
                notice.category === '학습' ? 'bg-emerald-100 text-emerald-600' :
                    notice.category === '지점' ? 'bg-amber-100 text-amber-600' :
                        'bg-slate-100 text-slate-500'
                }`}>
                <Bell size={18} className={notice.isPinned ? 'animate-pulse' : ''} />
            </div>

            <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                    {notice.isPinned && (
                        <span className="flex items-center text-indigo-600 font-bold text-[10px] uppercase tracking-wider">
                            <Pin size={10} className="mr-0.5 fill-current" />
                            Pinned
                        </span>
                    )}
                    <span className={`text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-md ${notice.category === '중요' ? 'bg-rose-50 text-rose-600' :
                        notice.category === '학습' ? 'bg-emerald-50 text-emerald-600' :
                            notice.category === '지점' ? 'bg-amber-50 text-amber-600' :
                                'bg-slate-50 text-slate-500'
                        }`}>
                        {notice.category}
                    </span>
                    <span className="text-[10px] font-medium text-slate-400">
                        {new Date(notice.createdAt).toLocaleDateString()}
                    </span>
                    <div className="flex items-center gap-1 text-[10px] font-medium text-slate-400 ml-auto sm:ml-0">
                        <Eye size={10} />
                        <span>{notice.viewCount}</span>
                    </div>
                </div>
                <h3 className="text-sm font-bold text-slate-800 truncate group-hover:text-indigo-600 transition-colors">
                    {notice.title}
                </h3>
            </div>

            <div className="hidden sm:flex w-8 h-8 rounded-full items-center justify-center bg-slate-50 text-slate-300 group-hover:bg-indigo-600 group-hover:text-white transition-all">
                <ChevronRight size={18} />
            </div>
        </button>
    );
};

export default StudentNoticeCard;
